import { Table } from "antd";

const tableColumns = (data) => {
  let tableColumns = [
    {
      title: "Summary",
      dataIndex: "category",
    },
  ];

  if (data.length > 0) {
    Object.keys(data[0]).forEach((key, idx) => {
      if (key == "category") return;
      tableColumns.push({
        title: key,
        dataIndex: key,
      });
    });
  }

  return tableColumns;
};

export default function SummaryTable({ data }) {
  const numberFormat = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

  // Function to format the data dynamically (excluding 'time' column)
  const formatData = (data) => {
    return data.map((item) => {
      let formattedItem = { ...item };
      Object.keys(item).forEach((key) => {
        if (key !== "time") {
          formattedItem[key] = item[key].toLocaleString("en-US", numberFormat); // Format numeric values to 2 decimal places and with commas
        }
      });
      return formattedItem;
    });
  };

  // Format the data
  const formattedData = formatData(data);

  return (
    <>
      <Table
        size="small"
        columns={tableColumns(formattedData)}
        pagination={false}
        dataSource={formattedData}
      ></Table>
    </>
  );
}
